import { Message, Loading } from 'element-ui'
import axios from 'axios'
import { localStore } from '@/utils/store'
import constHttpcode from '@/constant/httpcode'
import store from '@/store'
import { getValidParam } from '@/utils/tools'
import router from '@/router'

function handleDashboardRequestConfig(config) {
  const token = localStore.get('dashboard-token')
  if (token) {
    config.headers['token'] = token
  }
}
function handleCompetitorRequestConfig(config) {
  const token = localStore.get('competitor-token')
  if (token) {
    config.headers['token'] = token
  }
}
function handleJudgeRequestConfig(config) {
  const token = localStore.get('judge-token')
  if (token) {
    config.headers['token'] = token
  }
}

/**
 * 请求拦截
 */
axios.interceptors.request.use(
  (config) => {
    const currentRoutePath = router.history.current.path
    if (currentRoutePath.startsWith('/admin')) {
      handleDashboardRequestConfig(config)
    }
    if (currentRoutePath.startsWith('/competitor')) {
      handleCompetitorRequestConfig(config)
    }
    if (currentRoutePath.startsWith('/judge')) {
      handleJudgeRequestConfig(config)
    }

    config.data = getValidParam(config.data)
    config.params = getValidParam(config.params)
    if (
      config.headers['Content-Type'] === 'application/x-www-form-urlencoded'
    ) {
      const formData = new FormData()
      for (let k in config.data || {}) {
        if (Object.prototype.hasOwnProperty.call(config.data, k)) {
          formData.append(k, config.data[k])
        }
      }
      config.data = formData
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

/**
 * 响应拦截
 */
axios.interceptors.response.use(
  (response) => {
    const { data, headers } = response
    if (headers['content-type'] === 'application/vnd.ms-excel;charset=utf-8') {
      return {
        file: data,
        name: decodeURIComponent(headers['content-disposition'].split('=')[1])
      }
    }
    if (data.code === constHttpcode.SUCCESS) {
      return data.data
    }
    return Promise.reject({
      code: data.code,
      message: data.message
    })
  },
  ({ response }) => {
    if (response?.data) {
      return Promise.reject({
        code: response.data.code,
        message: response.data.message || 'server error'
      })
    }
    return Promise.reject({
      code: response.status,
      message: response.statusText || 'server error'
    })
  }
)

/**
 * Return Promise<any>
 * @param {object} headers 请求头部
 * @param {string} method 请求方式
 * @param {string} url 请求地址
 * @param {boolean} hideLoading 是否隐藏loading动画
 * @param {object} data Post 请求参数
 * @param {object} params Get 请求参数
 * @param {Function} processOptions options处理
 * @param {Function} processLang 中英文处理
 * @param {String} storeKey store唯一值
 */
const request = async (options = {}) => {
  const { processOptions, processLang } = options

  const {
    headers = {},
    method = 'GET',
    url = '/',
    hideLoading = false,
    hideError = false,
    data,
    params,
    storeKey,
    blob,
    ...config
  } = typeof processOptions === 'function' && processOptions(options)
    ? processOptions(options)
    : options

  let loadingInstance
  store.commit('loadingUpdate', {
    [storeKey]: true
  })

  if (!hideLoading) {
    loadingInstance = Loading.service({ fullscreen: true })
  }

  try {
    const res = await axios({
      method,
      url,
      headers,
      data,
      params,
      ...config
    })

    store.commit('exceptionUpdate', {
      [storeKey]: null
    })

    if (blob) return [null, res]

    return [null, typeof processLang === 'function' ? processLang(res) : res]
  } catch (error) {
    if (!hideError) {
      Message.error(error.message)
    }
    if (error.code === constHttpcode.UNAUTHORIZED) {
      localStore.clearAll()
      location.reload()
      return [error, null]
    }
    store.commit('exceptionUpdate', {
      [storeKey]: error
    })
    return [error, null]
  } finally {
    loadingInstance && loadingInstance.close()
    store.commit('loadingUpdate', {
      [storeKey]: false
    })
  }
}

export default request
